import { useMutation } from '@apollo/client';
import React from 'react';

import { cacheUtils } from '@eluve/apollo-client';
import {
  NewButton,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  useToast,
} from '@eluve/components';

import { removeCodeConfigFromGroupMutation } from './operations';

export const DeleteUserGroupCodeConfigCell: React.FC<{
  tenantId: string;
  configId: string;
}> = ({ tenantId, configId }) => {
  const toast = useToast();
  const [removeConfigFromGroup] = useMutation(
    removeCodeConfigFromGroupMutation,
    {
      variables: {
        tenantId,
        id: configId,
      },
      optimisticResponse: () => ({
        updateUserGroupCodeConfigsByPk: {
          __typename: 'UserGroupCodeConfigs' as const,
          id: configId,
        },
      }),
      update: () => {
        cacheUtils.evict({
          typeName: 'UserGroupCodeConfigs',
          key: { id: configId },
        });
      },
      onError: () => {
        toast.error('Failed to remove user group config');
      },
    },
  );

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <NewButton
          icon={{ name: 'Trash' }}
          onClick={() => removeConfigFromGroup()}
          type="outline"
        />
      </TooltipTrigger>
      <TooltipContent>Remove code from this group</TooltipContent>
    </Tooltip>
  );
};
